import { EstadoApi } from "../../bussines/entities/EstadoApi.entity";

export class EstadoApiModel implements EstadoApi {
    constructor(
        public orden: number,
        public modulo: string,
        public path: string,
        public estado: string,
        public tiempo: string,
        public status: number,
        public revisadoEn: string,
        public mensaje: string
    ) { }

    serialize(): EstadoApi {
        return {
            orden: this.orden,
            modulo: this.modulo,
            path: this.path,
            estado: this.estado,
            tiempo: this.tiempo,
            status: this.status,
            revisadoEn: this.revisadoEn,
            mensaje: this.mensaje
        }
    }

    static deserialize(entity: EstadoApi): EstadoApiModel {
        return new EstadoApiModel(
            entity.orden ?? 0,
            entity.modulo ?? '',
            entity.path ?? '',
            entity.estado ?? '',
            entity.tiempo ?? '',
            entity.status ?? 0,
            entity.revisadoEn ?? '',
            entity.mensaje ?? ''
        );
    }
}